/** 默认金币数 */
export default {
};
